import { appMode } from '../types';
import { lang } from '@lang';
import { State } from './state.type';

export const stateInitializer = (): State => {
	return {
		isBootstrapped: true,
		isNavigationReady: false,
		whatsLoading: lang.app.loading.bootstrap,
		// Dev defaults to the shared test contact so a real customer's CRM is never touched by accident.
		useTestContact: import.meta.env.DEV,
		nav: {
			appMode: appMode.rta,
			email: null,
			designId: null,
			designVersion: null,
			draft: false,
			reset: false,
			options: {}
		}
	};
};
